<template>
  <div class="message-box">
    <div class="list">
      <div class="message-item" v-for="(item, index) in list" :key="index">
        <div class="m-hender">
          <span class="name">{{ item.employeeName }}</span>
          <span class="time">{{ item.crDt }}</span>
        </div>
        <template v-if="isSelf">
          <div class="msg msg-type2">
            <div class="plan">
              <span> 主诉：{{ item.chiefComplaint }} </span>
              <span> 诊断：{{ info.diseaseName }} </span>
            </div>
            <div class="btn" v-if="item.submitType">
              <Button @click="showDetail(item, false)">
                <Icon type="ios-paper-outline" />
                预备方案详情</Button
              >
            </div>
            <div class="btn" v-else-if="isLook">
              <Button @click="showDetail(item, false)" disabled
                >无预备方案</Button
              >
            </div>
            <div class="btn" v-else>
              <Button @click="show(item)" type="text">
                <Icon class="red" type="md-add-circle" />
                添加预备方案
                <Badge status="error" />
              </Button>
              <Button @click="quote(item)">引用上次方案</Button>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="item.recordType == 5" class="msg msg-type1">
            <div class="msg-text">
              <span>{{item.record}}</span>
            </div>
          </div>
          <div v-if="item.recordType == 1" class="msg msg-type1">
            <div class="msg-text">
              咨询【{{ info.benchmarkDoctorName }}】医生【{{
                info.diseaseName
              }}】的治疗方案
            </div>
          </div>
          <div v-else-if="item.recordType == 2" class="msg msg-type2">
            <template v-if="info.expertiseType == 6">
              <div class="plan">
                <Icon type="ios-paper-outline" />
                【{{ info.diseaseName }}】的治疗方案（{{
                  item.noIntegrityNum
                    ? item.noIntegrityNum + "个思路不完整"
                    : "思路完整"
                }}）
              </div>
              <div class="btn">
                <Button v-if="showBtn(item)" @click="showDetail(item, true)"
                  >去补充</Button
                >
                <Button v-else @click="showDetail(item, false)"
                  >查看详情</Button
                >
              </div>
            </template>
            <template v-else>
              <div class="plan">
                <Icon type="ios-paper-outline" />
                【{{ info.diseaseName }}】的治疗方案（{{ item.planNum }}个思路）
              </div>
              <div class="btn">
                <Button @click="showDetail(item, false)">查看详情</Button>
              </div>
            </template>
          </div>
          <div v-else-if="item.recordType == 3" class="msg msg-type1">
            <div class="msg-text">
              {{ item.record }}
            </div>
          </div>
        </template>
      </div>
      <div class="m-end" ref="m-end"></div>
    </div>
    <treatmentPlan
      ref="treatmentPlanRef"
      :info="info"
      :activeItem="activeItem"
      @change="getData"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import treatmentPlan from "./treatmentPlan.vue";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrBefore);
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isLook: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    treatmentPlan,
  },
  computed: {
    isSelf() {
      return [4, 5, "4", "5"].includes(this.info.expertiseType);
    },
  },
  watch: {
    info(newValue, oldValue) {
      this.getData();
    },
  },
  data() {
    return {
      list: [],
      activeItem: {},
    };
  },
  methods: {
    showBtn(item) {
      return (
        item.isEnd &&
        dayjs(item.lastTimeVisitDate).isSameOrBefore(item.crDt, "day")
      );
    },
    quote(item) {
      Object.assign(this.activeItem, item || { merId: "" });
      this.$refs.treatmentPlanRef.quote();
    },
    show(item) {
      if (item) {
        Object.assign(this.activeItem, item);
      } else {
        this.activeItem.merId = "";
      }
      this.$refs.treatmentPlanRef.show();
    },
    showDetail(item, isSupplement) {
      Object.assign(this.activeItem, item);
      this.request
        .post("/zhbusiness/getMedicalExpertisePlan", {
          merId: item.merId,
        })
        .then((res) => {
          let list = res.result.map((i, index) => {
            i.medicalRecordInfo = JSON.parse(i.medicalRecordInfo);
            i.value = index;
            i.label = i.planName;
            i.tabooDrugList = i.tabooDrugList || [];
            return i;
          });
          this.$refs.treatmentPlanRef.show(list, isSupplement);
        });
    },
    getData() {
      if (!this.info) return;
      let obj = {
        meId: this.info.meId,
        patientCode: this.info.patientCode,
      };
      let api =
        this.info.expertiseType == 6
          ? "/zhbusiness/getSupplementMeRecord"
          : "/zhbusiness/getMedicalExpertiseRecord";
      this.request.post(api, obj).then((res) => {
        let arr = res.result.map((i) => {
          i.isEnd = false;
          i.expertiseType = this.info.expertiseType;
          return i;
        });
        if (arr.length) {
          arr[arr.length - 1].isEnd = true; //用于处理是否处于可以编辑的那条
        }
        this.list = arr;
        this.toEnd();
        this.$store.dispatch("todoNumber");
      });
    },
    toEnd() {
      this.$nextTick(() => {
        this.$refs["m-end"].scrollIntoView({ behavior: "smooth" });
      });
    },
    refresh(res) {
      if (res.meId == this.info.meId) {
        this.getData();
      }
    },
  },
  mounted() {
    this.getData();
    this.$bus.on("MEMessage", this.refresh);
  },
  beforeDestroy() {
    this.$bus.off("MEMessage", this.refresh);
  },
};
</script>

<style lang="scss" scoped>
.message-box {
  height: 100%;
  padding: 15px 20px;
  overflow-y: auto;
  .message-item {
    margin-bottom: 15px;
    .m-hender {
      margin-bottom: 5px;
      & > * {
        margin-right: 15px;
      }
      .name {
        font-weight: bold;
        font-size: 15px;
      }
      .time {
        font-size: 12px;
      }
    }
    .msg-type2 {
      display: inline-block;
      border: 1px solid #ddd;
      padding: 15px;
      border-radius: 5px;
      .plan {
        margin-bottom: 10px;
        span {
          margin-right: 30px;
        }
      }
      .ivu-icon {
        color: #c07a11;
        font-weight: bold;
        font-size: 18px;
        &.red {
          color: red;
        }
      }
    }
    .msg-text {
      background: #f5f5f5;
      display: inline-block;
      border-radius: 5px;
      padding: 5px 10px;
    }
  }
}
</style>